<template lang="pug">
div
  slot(:rfb="rfb")
</template>
<script>
export default {
  props: {
    concern:   {type: Object, required: true},
    formBlock: {type: Object, required: true},
  },
  computed: {
    rfb(){
      const rfb = this.state.current_reg.find_rblock(this.formBlock)

      this.$set(rfb, "entity_attrs", this.concern)
      this.$set(rfb,"entity_id", rfb.entity_attrs.id)

      rfb.custom_attrs || this.$set(rfb, "custom_attrs", {})
      rfb.entity_attrs || this.$set(rfb, "entity_attrs", {})
      // no need bu can use in future
      // for (const id of form_block.custom_field_ids){
      //   rfb.custom_attrs[id] = this.registration.personCustomFields[id]?.values || []
      // }
      return rfb
    },
  },
  // watch:{
  //   concern(){
  //     console.log("concern changed: ", this.concern)
  //   }
  // },
}
</script>